import VMasker from 'vanilla-masker/lib/vanilla-masker';
import { API_PATH, EMAIL_REGEX, BASE_PATH } from '../../constants';
import Modal from '../../components/modal/index';

//Function to validate email
const validateEmail = async (email) => {
    let res = await fetch(`api/verify-email/${email}`);
    let response = await res.json();

    return response
}

//Function validate phone
const validatePhone = async (phone) => {
    let res = await fetch(`api/verify-phone/${phone}`);
    let response = await res.json();

    return response
}

(() => {
    const url = new URL(window.location.href);

    const selectors = {
        btnOk: document.getElementById('btn-ok'),
        msgSuccess: document.getElementById('modal-message__desc'),
        msgStatus: document.getElementById('modal-message__status'),
        modalMessage: '#modal-message'
    };

    const simulationData = {
        type: "simulador",
        region: url.searchParams.get('regions') ? url.searchParams.get('regions') : '',
        name: '',
        email: '',
        phone: '',
        fgts: '',
        start_budget: '',
        origin: 'Simulador',
        product_id: url.searchParams.get('productId'),
        product_name: '',
        uf: window.state,
        chat_url: '',
        optin_tel: 0,
        optin_sms: 0,
        optin_whatsapp: 0,
        optin_email: 0
        // price_range: url.searchParams.get('price_range') ? url.searchParams.get('price_range') : ''
    };

    const messages = {
        failed: 'Oops, tente novamente mais tarde.'
    };

    const cssClasses = {
        failed: 'icon-status--failed'
    };

    const inputHandler = (masks, max, event) => {
        let c = event.target;
        let v = c.value.replace(/\D/g, '');
        let m = c.value.length > max ? 1 : 0;
        VMasker(c).unMask();
        VMasker(c).maskPattern(masks[m]);
        c.value = VMasker.toPattern(v, masks[m]);
    };

    let telMask = ['(99) 9999-99999', '(99) 99999-9999'];
    let tel = document.querySelector('[type="tel"]');
    VMasker(tel).maskPattern(telMask[0]);
    tel.addEventListener('input', inputHandler.bind(undefined, telMask, 14), false);

    const totalSteps = document.getElementsByClassName('simulator-step-section').length - 1;
    // document.getElementById('step-total').innerHTML = totalSteps;

    const changeStep = (toStep) => {
        console.log('changeStep', toStep);
        document.body.classList.add('changing-simulator-step');

        switch (toStep) {
            case 2:
                setTimeout(() => document.getElementById('simulator-name').focus(), 205);
                break;

            case 3:
                setTimeout(() => document.getElementById('simulator-email').focus(), 205);
                break;

            case 4:
                setTimeout(() => document.getElementById('simulator-phone').focus(), 205);
                break;
        }

        window.setTimeout(() => {
            document.body.classList.remove('changing-simulator-step');

            const nums = document.getElementsByClassName('simulator-nums-item active');
            const steps = document.getElementsByClassName('simulator-step-section active');

            while (nums[0]) {
                nums[0].classList.remove('active');
            }
            while (steps[0]) {
                steps[0].classList.remove('active');
            }

            document.querySelector(`[data-num="${toStep}"]`).classList.add('active');
            document.querySelector(`[data-step="${toStep}"]`).classList.add('active');
            // document.getElementById('step-current').innerHTML = toStep - 1;
        }, 200);
    };

    //STEP1
    const regionElement = document.getElementById('simulator-region');

    if (regionElement.value) {
        simulationData.region = regionElement.value;
        document.getElementById('btn-step1').disabled = false;
    }

    if (simulationData.region != '') {
        regionElement.value = simulationData.region;
        regionElement.classList.add('selected');
        document.getElementById('btn-step1').disabled = false;
    }

    regionElement.addEventListener('change', function (event) {
        simulationData.region = event.target.value;
        this.classList.add('selected');
        document.getElementById('btn-step1').disabled = false;
    });

    document.getElementById('btn-step1').addEventListener('click', function (event) {
        event.preventDefault();
        changeStep(2);
    });

    //STEP2

    document.getElementById('simulator-name').addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
            simulationData.name = event.target.value;
            document.getElementById('btn-step2').click();
            return;
        }

        document.getElementById('btn-step2').disabled = !this.value.length;

        if (this.value.length) {
            document.getElementById('simulator-name').classList.add('selected');
        } else {
            document.getElementById('simulator-name').classList.remove('selected');
        }
    });

    document.getElementById('btn-back-step2').addEventListener('click', function (event) {
        event.preventDefault();
        changeStep(1);
    });

    document.getElementById('btn-step2').addEventListener('click', function (event) {
        simulationData.name = document.getElementById('simulator-name').value;
        // console.log('Simulation Data : ', simulationData);
        event.preventDefault();
        changeStep(3);
    });

    //STEP3

    let checkStep3 = function () {
        let email = document.getElementById('simulator-email').value;
        let checkEmail = document.getElementById('optin_email').checked;

        return EMAIL_REGEX.test(String(email).toLowerCase()) && checkEmail;
    }

    document.getElementById('simulator-email').addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
            simulationData.email = event.target.value;
            document.getElementById('btn-step3').click();
            return;
        }

        document.getElementById('btn-step3').disabled = !checkStep3();

        if (this.value.length) {
            document.getElementById('simulator-email').classList.add('selected');
        } else {
            document.getElementById('simulator-email').classList.remove('selected');
        }
    });

    document.getElementById('optin_email').addEventListener('change', function (e) {
        document.getElementById('btn-step3').disabled = !checkStep3();
    });

    document.getElementById('btn-back-step3').addEventListener('click', function (event) {
        event.preventDefault();
        changeStep(2);
    });

    document.getElementById('btn-step3').addEventListener('click', function (event) {
        simulationData.email = document.getElementById('simulator-email').value;
        // console.log('Simulation Data : ', simulationData);
        event.preventDefault();

        document.body.classList.add('changing-simulator-step', 'is-loading');
        validateEmail(document.getElementById('simulator-email').value)
            .then(res => {
                if (res.success) {
                    document.getElementById('simulator-email-error').style.display = 'none';
                    document.body.classList.remove('changing-simulator-step', 'is-loading');
                    changeStep(4)
                } else {
                    document.getElementById('simulator-email-error').style.display = 'block';
                    document.body.classList.remove('changing-simulator-step', 'is-loading');
                    document.getElementById('simulator-email-error').innerText = 'Insira um e-mail válido!'
                }
            });
    });

    //STEP4

    let checkStep4 = function () {
        let phone = document.getElementById('simulator-phone').value;
        let checkTels = ['optin_tel', 'optin_sms', 'optin_whatsapp'].reduce((prev, current) => {
            let check = document.getElementById(current).checked;
            return prev && check;
        }, true);

        return (phone.length >= 14) && checkTels;
    }

    document.getElementById('simulator-phone').addEventListener('keyup', function (event) {
        if (event.keyCode === 13) {
            simulationData.phone = event.target.value;
            document.getElementById('btn-step4').click();
            return;
        }

        document.getElementById('btn-step4').disabled = !checkStep4();

        if (this.value.length) {
            document.getElementById('simulator-phone').classList.add('selected');
        } else {
            document.getElementById('simulator-phone').classList.remove('selected');
        }
    });

    ['optin_tel', 'optin_sms', 'optin_whatsapp'].forEach(function (elem) {
        document.getElementById(elem).addEventListener('change', function (e) {
            document.getElementById('btn-step4').disabled = !checkStep4();
        });
    });

    document.getElementById('btn-back-step4').addEventListener('click', function (event) {
        event.preventDefault();
        changeStep(3);
    });

    document.getElementById('btn-step4').addEventListener('click', function (event) {
        simulationData.phone = document.getElementById('simulator-phone').value;
        // console.log('Simulation Data : ', simulationData);
        event.preventDefault();
        document.body.classList.add('changing-simulator-step', 'is-loading');
        validatePhone(document.getElementById('simulator-phone').value)
            .then(res => {
                if (res.success) {
                    document.getElementById('simulator-phone-error').style.display = 'none';
                    document.body.classList.remove('changing-simulator-step', 'is-loading');
                    //changeStep(5)

                    document.querySelector('.simulator-nums').classList.add('hide-effect');

                    window.setTimeout(() => {
                        document.querySelector('.simulator-nums').classList.add('hidden');
                        document.querySelector('[data-step="5"]').classList.add('loading');
                        document.querySelector('[data-step="5"]').classList.add('active');
                        document.querySelector('[data-step="4"]').classList.remove('active');

                        simulationData.optin_tel = document.getElementById('optin_tel').checked ? 1 : 0;
                        simulationData.optin_sms = document.getElementById('optin_sms').checked ? 1 : 0;
                        simulationData.optin_whatsapp = document.getElementById('optin_whatsapp').checked ? 1 : 0;
                        simulationData.optin_email = document.getElementById('optin_email').checked ? 1 : 0;

                        axios.post(`${API_PATH}/simulation`, simulationData)
                            .then((response) => {
                                const res = response.data;
                                let regExp = /\(([^)]+)\)/;
                                let ddd = regExp.exec(simulationData.phone)[1];
                                let phone = simulationData.phone.split(')')[1];

                                let clientName = res.data.client_name;
                                let clientCode = res.data.client_validate_code;

                                simulationData.uf = response.data.data.uf || sadaptadorimulationData.uf;
                                simulationData.product_name = response.data.data.product_name;
                                simulationData.chat_url = response.data.data.chat_url;

                                document.querySelector('[data-step="5"] .contact-user-name').innerHTML = clientName;
                                document.querySelector('[data-step="5"] .contact-user-code').innerHTML = clientCode;

                                // console.log('Response Data :: ', res.data);
                                // document.getElementById('step-current').innerHTML = totalSteps;
                                document.querySelector('[data-step="5"]').classList.remove('loading');

                                if(typeof GTM === 'function'){
                                    GTM('gaTriggerEvent', 'conversao', 'email', 'simule_financiamento');
                                }

                                document.getElementById('direcionar-chat-simulador').addEventListener('click', function (e) {
                                    // GTM('gaTriggerEvent', 'conversao', 'email', 'simule_financiamento');
                                    // window.startChat(simulationData);

                                    window.location.href = BASE_PATH;
                                });
                            })
                            .catch((error) => {
                                console.log(error);
                                const modal = new Modal(selectors.modalMessage, false);
                                selectors.msgStatus.classList.add(cssClasses.failed);
                                selectors.msgSuccess.innerHTML = messages.failed;
                                selectors.btnOk.addEventListener('click', () => {
                                    modal.closeModal();
                                    setTimeout(() => location.reload(), 1000);
                                });

                                console.log(error);
                                modal.openModal();
                            })
                    }, 200);

                } else {
                    document.getElementById('simulator-phone-error').style.display = 'block';
                    document.body.classList.remove('changing-simulator-step', 'is-loading');
                    document.getElementById('simulator-phone-error').innerText = 'Insira um telefone válido!'
                }
            });
    });

    //STEP5

    // const priceRangeElement = document.getElementById('simulator-price');

    if (simulationData.region != '') {
        // priceRangeElement.value = simulationData.price_range;
        document.getElementById('btn-step5').disabled = false;
    }

    Array.prototype.forEach
        .call(document.querySelectorAll('input[name=fgts]'), (el) => {
            el.addEventListener('change', (event) => {
                simulationData.fgts = String(event.target.value) === 'true';
                allChecked();
            });
        });

    Array.prototype.forEach
        .call(document.querySelectorAll('input[name=input-value]'), (el) => {
            el.addEventListener('change', (event) => {
                simulationData.start_budget = String(event.target.value) === 'true';
                allChecked();
            });
        });


    function allChecked() {
        const isFGTS = document.querySelectorAll('input[name=fgts]:checked');
        const isInpValue = document.querySelectorAll('input[name=input-value]:checked');

        // console.log('Simulation Data : ', simulationData);

        if (isFGTS.length > 0 && isInpValue.length > 0) document.getElementById('btn-step5').disabled = false;
    }

    // priceRangeElement.addEventListener('change', function (event) {
    //     simulationData.price_range = event.target.value;

    //     console.log('Price Range :: ', event.target.value);
    //     console.log('Simulation Data : ', simulationData);

    //     this.classList.add('selected');
    //     document.getElementById('btn-step5').disabled = false;
    // });

    document.getElementById('btn-back-step5').addEventListener('click', function (event) {
        event.preventDefault();
        changeStep(4);
    });

    // document.getElementById('btn-step5').addEventListener('click', function (event) {
    //     event.preventDefault();
    //     document.querySelector('.simulator-nums').classList.add('hide-effect');
    //
    //     window.setTimeout(() => {
    //         document.querySelector('.simulator-nums').classList.add('hidden');
    //         document.querySelector('[data-step="6"]').classList.add('loading');
    //         document.querySelector('[data-step="6"]').classList.add('active');
    //         document.querySelector('[data-step="5"]').classList.remove('active');
    //
    //         simulationData.optin_tel = document.getElementById('optin_tel').checked ? 1 : 0;
    //         simulationData.optin_sms = document.getElementById('optin_sms').checked ? 1 : 0;
    //         simulationData.optin_whatsapp = document.getElementById('optin_whatsapp').checked ? 1 : 0;
    //         simulationData.optin_email = document.getElementById('optin_email').checked ? 1 : 0;
    //
    //         axios.post(`${API_PATH}/simulation`, simulationData)
    //             .then((response) => {
    //                 const res = response.data;
    //                 let regExp = /\(([^)]+)\)/;
    //                 let ddd = regExp.exec(simulationData.phone)[1];
    //                 let phone = simulationData.phone.split(')')[1];
    //
    //                 let clientName = res.data.client_name;
    //                 let clientCode = res.data.client_validate_code;
    //
    //                 simulationData.uf = response.data.data.uf || sadaptadorimulationData.uf;
    //                 simulationData.product_name = response.data.data.product_name;
    //                 simulationData.chat_url = response.data.data.chat_url;
    //
    //                 document.querySelector('[data-step="6"] .contact-user-name').innerHTML = clientName;
    //                 document.querySelector('[data-step="6"] .contact-user-code').innerHTML = clientCode;
    //
    //                 // console.log('Response Data :: ', res.data);
    //                 // document.getElementById('step-current').innerHTML = totalSteps;
    //                 document.querySelector('[data-step="6"]').classList.remove('loading');
    //
    //                 if(typeof GTM === 'function'){
    //                     GTM('gaTriggerEvent', 'conversao', 'email', 'simule_financiamento');
    //                 }
    //
    //                 document.getElementById('direcionar-chat-simulador').addEventListener('click', function (e) {
    //                     // GTM('gaTriggerEvent', 'conversao', 'email', 'simule_financiamento');
    //                     // window.startChat(simulationData);
    //
    //                     window.location.href = BASE_PATH;
    //                 });
    //             })
    //             .catch((error) => {
    //                 console.log(error);
    //                 const modal = new Modal(selectors.modalMessage, false);
    //                 selectors.msgStatus.classList.add(cssClasses.failed);
    //                 selectors.msgSuccess.innerHTML = messages.failed;
    //                 selectors.btnOk.addEventListener('click', () => {
    //                     modal.closeModal();
    //                     setTimeout(() => location.reload(), 1000);
    //                 });
    //
    //                 console.log(error);
    //                 modal.openModal();
    //             })
    //     }, 200);
    // });
})();